import FhToastService from "../../components/FhToast/FhToastService/FhToastService.mjs";
const FhToastPlugin = {
  install: (app) => {
    app.config.globalProperties.$toast = FhToastService;
  }
};
export {
  FhToastPlugin as default
};
//# sourceMappingURL=FhToastPlugin.mjs.map
